const TYPE = {
    LOGIN_SUCCESS: "LOGIN_SUCCESS",
    LOGIN_FAIL: "LOGIN_FAIL",
    VERIFY_SUCCESS: "VERIFY_SUCCESS",
    VERIFY_FAIL: "VERIFY_FAIL",
    GET_USER_REQ:"GET_USER_REQ",
    GET_USER_SUCCESS: "GET_USER_SUCCESS",
    GET_USER_FAIL: "GET_USER_FAIL",
    REFRESH_SUCCESS: "REFRESH_SUCCESS",
    REFRESH_FAIL: "REFRESH_FAIL",
    CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
    CHANGE_PASSWORD_FAIL: "CHANGE_PASSWORD_FAIL",
    SIGNUP_SUCCESS: "SIGNUP_SUCCESS",
    SIGNUP_FAIL: "SIGNUP_FAIL",
    CONTACTUS_SUCCESS: "CONTACTUS_SUCCESS",
    CONTACTUS_FAIL: "CONTACTUS_FAIL",
    ACTIVATE_ACCTOUNT_SUCCESS: "ACTIVATE_ACCTOUNT_SUCCESS",
    ACTIVATE_ACCTOUNT_FAIL: "ACTIVATE_ACCTOUNT_FAIL",
    RESET_SUCCESS: "RESET_SUCCESS",
    RESET_FAIL: "RESET_FAIL",
    SET_SUCCESS: "SET_SUCCESS",
    SET_FAIL: "SET_FAIL",
    LOGOUT: "LOGOUT",
    CLOSE_ALERT: "CLOSE_ALERT",
    GUEST_VIEW: "GUEST_VIEW",

    GET_USER_DETAILS_SUCCESS:"GET_USER_DETAILS_SUCCESS",
    GET_USER_DETAILS_FAIL:"GET_USER_DETAILS_FAIL"
}

export default TYPE